<template>
  <div v-if="banners.length" class="Cover">
    <section class="section home-section p-0">
      <div class="inner-wrap">
            <slick
              ref="slick"
              :options="slickOptions"
              @afterChange="handleAfterChange"
              @beforeChange="handleBeforeChange"
              @breakpoint="handleBreakpoint"
              @destroy="handleDestroy"
              @edge="handleEdge"
              @init="handleInit"
              @reInit="handleReInit"
              @setPosition="handleSetPosition"
              @swipe="handleSwipe"
              @lazyLoaded="handleLazyLoaded"
              @lazyLoadError="handleLazeLoadError">
              <img v-for="(banner, index) in banners" :key="index" :src="banner.url">
            </slick>
        </div>
    </section>
  </div>
</template>
<script>
import Slick from 'vue-slick'

export default {
  name: 'Cover',
  components: {Slick},
  props: {
    banners: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
            slickOptions: {
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 5000,
                dots: false,
                arrows: false,
                infinite: true,
                accessibility: false,
            },
        };
  },
  computed: {},
  created () {
    
  },
  // All slick methods can be used too, example here
    methods: {
        next() {
            this.$refs.slick.next();
        },

        prev() {
            this.$refs.slick.prev();
        },

        reInit() {
            // Helpful if you have to deal with v-for to update dynamic lists
            this.$nextTick(() => {
                this.$refs.slick.reSlick();
            });
        },

        // Events listeners
        handleAfterChange(event, slick, currentSlide) {
            // console.log('handleAfterChange', event, slick, currentSlide);
        },
        handleBeforeChange(event, slick, currentSlide, nextSlide) {
            // console.log('handleBeforeChange', event, slick, currentSlide, nextSlide);
        },
        handleBreakpoint(event, slick, breakpoint) {
            // console.log('handleBreakpoint', event, slick, breakpoint);
        },
        handleDestroy(event, slick) {
            // console.log('handleDestroy', event, slick);
        },
        handleEdge(event, slick, direction) {
            // console.log('handleEdge', event, slick, direction);
        },
        handleInit(event, slick) {
            // console.log('handleInit', event, slick);
        },
        handleReInit(event, slick) {
            // console.log('handleReInit', event, slick);
        },
        handleSetPosition(event, slick) {
            // console.log('handleSetPosition', event, slick);
        },
        handleSwipe(event, slick, direction) {
            // console.log('handleSwipe', event, slick, direction);
        },
        handleLazyLoaded(event, slick, image, imageSource) {
            // console.log('handleLazyLoaded', event, slick, image, imageSource);
        },
        handleLazeLoadError(event, slick, image, imageSource) {
            // console.log('handleLazeLoadError', event, slick, image, imageSource);
        },
    },
}
</script>

<style lang="scss" scoped>

</style>